import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { COLORS, SPACE } from '../../../../theme/tokens';

/** The body's own box (named for the morph): as wide as its home, the rail's column or the whole sheet. */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Lead = styled(Text)`
  display: block;
  margin-top: ${SPACE[4]};
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;

/** The Ingredients accordion: its sections stack flush, each with its own hairline below (the first, one above too). */
/* The space below keeps the Extract footer's border clear of the last section (open, it would touch it). */
export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${SPACE[12]};
  margin-bottom: ${SPACE[12]};
`;

/** A mood board image full size, centred in its sheet. */
export const PreviewBody = styled.div`
  display: grid;
  place-items: center;
`;

export const PreviewImg = styled.img`
  display: block;
  max-width: 100%;
  max-height: 68vh;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid ${COLORS.hairline};
`;
